import styled from 'styled-components'

export const Logout = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: none;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
  text-align: left;
  padding: 10px 16px;
  cursor: pointer;
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.action.danger.bg};
  transition: background 0.15s ease, color 0.15s ease;

  svg {
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(220, 38, 38, 0.14)'
        : 'rgba(220, 38, 38, 0.06)'};
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.danger.bg};
    outline-offset: -2px;
  }
`
